module.exports = __webpack_public_path__ + "./landing-page-mov_a0b160b42a3d68ec5d7a44c795686460.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/static/videos/landing-page-mov.mp4
// module id = 638
// module chunks = 0